<template>
  <v-card class="ma-2">
    <v-card-title v-if="company === 'fibraclim'">DATOS DE USUARIO</v-card-title>
    <v-card-title v-if="company !== 'fibraclim'">DATOS DE DISTRIBUIDOR</v-card-title>
    <v-card-subtitle v-if="company === 'fibraclim'">Introduce los datos del usuario/cliente que ha comprado el producto
    </v-card-subtitle>
    <v-card-subtitle v-if="company !== 'fibraclim'">Introduce los datos del instalador o distribuidor</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-text-field
            class="ma-1"
            :label="company !== 'fibraclim' ? 'Nombre del distribuidor': 'Nombre'"
            v-model="info.name"
            :rules="[rules.required]"
            outlined/>
        <v-text-field
            class="ma-1"
            label="NIF / CIF"
            v-model="info.nif"
            :rules="[rules.required]"
            outlined/>
      </v-row>
      <v-row>
        <v-text-field
            class="ma-1"
            label="Dirección"
            v-model="info.address"
            :rules="[rules.required]"
            outlined/>
        <v-text-field
            class="ma-1"
            label="Localidad"
            v-model="info.city"
            :rules="[rules.required]"
            outlined/>
      </v-row>
      <v-row>
        <v-text-field
            class="ma-1"
            label="Provincia"
            v-model="info.state"
            :rules="[rules.required]"
            outlined/>
        <v-text-field
            class="ma-1"
            label="Código postal"
            v-model="info.postalCode"
            :rules="[rules.required]"
            outlined/>
      </v-row>
      <v-row>
        <v-text-field
            class="ma-1"
            label="Email"
            v-model="info.email"
            :rules="[rules.required, rules.email]"
            outlined/>
        <v-text-field
            class="ma-1"
            label="Teléfono"
            v-model="info.phone"
            :rules="[rules.required]"
            outlined/>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EntityInfo",
  props: ["info", "company"],
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        email: v => /.+@.+\..+/.test(v) || 'El E-mail debe tener un formato válido'
      }
    }
  }
}
</script>

<style scoped>

</style>